import { PromptLibrary as PromptLibraryComponent } from '../components/PromptSelector'

export function PromptLibrary() {
  return <PromptLibraryComponent />
}